// ----------------------------------------------------------------------

export type LanguageValue = 'en' | 'fr' | 'rw' | 'sw' | 'ar';

export const fallbackLng = 'en';
export const languages = ['en', 'fr', 'rw', 'sw', 'ar'];
export const defaultNS = 'common';
export const allNS = [
  'common',
  'navbar',
  'agents',
  'campaigns',
  'dashboard',
  'osa',
  'payroll',
  'reports',
  'runs',
  'settings',
  'wallet',
];
export const cookieName = 'i18next';

// ----------------------------------------------------------------------

export function i18nOptions(lng = fallbackLng, ns: string | string[] = allNS) {
  return {
    // debug: true,
    lng,
    fallbackLng,
    ns,
    defaultNS,
    fallbackNS: defaultNS,
    supportedLngs: languages,
  };
}

// ----------------------------------------------------------------------

export const changeLangMessages: Record<
  LanguageValue,
  { success: string; error: string; loading: string }
> = {
  en: {
    success: 'Language has been changed!',
    error: 'Error changing language!',
    loading: 'Loading...',
  },
  fr: {
    success: 'La langue a été changée!',
    error: 'Erreur lors du changement de langue!',
    loading: 'Chargement...',
  },
  sw: {
    success: 'Lugha imebadilishwa!',
    error: 'Hitilafu katika kubadilisha lugha!',
    loading: 'Inapakia...',
  },
  rw: {
    success: "Ururimi rwahinduwe!",
    error: "Habayeho ikosa mu guhindura ururimi!",
    loading: 'Birimo gupakururwa...',
  },
  ar: {
    success: 'تم تغيير اللغة!',
    error: 'خطأ في تغيير اللغة!',
    loading: 'جاري التحميل...',
  },
};
